module.exports = __webpack_public_path__ + "img/epr@2x.3587e4b1.webp";